import { render } from "./RatingComponent.vue?vue&type=template&id=d54c7d12"
import script from "./RatingComponent.vue?vue&type=script&lang=js"
export * from "./RatingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__